<div class="card home-projects box-shadow">
    <div class="row equal card-body">
        <p class="col h4">
            <strong class="home-title">{{ 'home.feed.title' | translate }}</strong>
        </p>

        <ng-container *ngIf="!projectsLoaded">
            <wudo-spinner></wudo-spinner>
        </ng-container>

        <div class="project-list row pl-4 pr-4">
            <div *ngFor="let project of projects" class="card-group col-sm-4" [routerLink]="['/projects', project.id]">
                <div class="card with-border project-pointer">
                    <div class="card-body">
                        <div class="img-container">
                            <img class="card-img-top" src="{{ project.coverUrl }}" alt="Card image cap" />
                        </div>
                        <div class="row align-items-center mt-2">
                            <div class="col-12 col-sm-12">
                                <h5 class="card-title home-title">
                                    {{ project.name }}
                                </h5>
                                <p class="primary-1 card-text project-category">
                                    {{ project.typeLabel | wtranslate : 'projectTypes' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
